<template>
  <div class="contentDetails">
    <NavBar :navBlock="navBlock" :navtitle="navtitle" :pageBack="true"></NavBar>
    <div class="detailsContent">
      <div class="detailsTitle">
        <div class="detailsWrap"></div>
        <p>個人設置</p>
      </div>
      <el-form>
        <!-- :http-request='uploadRequest' -->
        <el-form-item label="暱稱 : ">
          <input
            maxlength="10"
            class="el-input__inner"
            type="text"
            v-model="nickName"
          />
        </el-form-item>
        <el-form-item label="頭像 : " class="picupload">
          <el-upload
            class="avatar-uploader"
            action=""
            :headers="{ Authorization: this.$cookie.get('auth') }"
            :with-credentials="true"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :auto-upload="false"
            :on-change="getUploadFile"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <el-dialog
        title="图片剪裁"
        :visible.sync="dialogVisiblePic"
        append-to-body
      >
        <div class="cropper-content">
          <div class="cropper" style="text-align:center">
            <vueCropper
              ref="cropper"
              :img="option.img"
              :outputSize="option.size"
              :outputType="option.outputType"
              :info="true"
              :full="option.full"
              :canMove="option.canMove"
              :canMoveBox="option.canMoveBox"
              :original="option.original"
              :autoCrop="option.autoCrop"
              :fixed="option.fixed"
              :fixedNumber="option.fixedNumber"
              :centerBox="option.centerBox"
              :infoTrue="option.infoTrue"
              :fixedBox="option.fixedBox"
            ></vueCropper>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisiblePic = false">取 消</el-button>
          <el-button type="primary" @click="finish()">确认</el-button>
        </div>
      </el-dialog>
      <div class="bottomBtn">
        <div class="btn" @click="saveAlert()">保存修改</div>
      </div>

      <DiaMess v-if="dialogVisible"></DiaMess>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";

export default {
  data() {
    return {
      navBlock: "個人設置",
      navtitle: "修改個人設置",
      nickName: "",
      imageUrl: "",
      dialogVisible: false,
      dialogVisiblePic: false,
      option: {
        img: "", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        // fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      fileinfo: ""
    };
  },
  created() {
    this.nickName = localStorage.getItem("nickName");
    this.imageUrl = localStorage.getItem("avatarPic");
  },
  methods: {
    //上传图片之前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        _this.dialogVisible = true;
        _this.$propMessage("上傳圖片只能是jpg或者png格式", "error", function() {
          _this.dialogVisible = false;
        });

        return false;
      }
      if (!isLt2M) {
        _this.dialogVisible = true;
        _this.$propMessage("上傳圖片大小不能超過20MB", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      return isJPG && isLt2M;
    },
    //   上传图片
    uploadRequest(option) {
      const file = option.file;
      const self = this;
      return new Promise((resolve, reject) => {
        const date = self.$dateFormat(new Date(), "yyyy-MM-dd"); // 当前时间
        const dateTime = self.$dateFormat(new Date(), "yyyyMMddhhmmss"); // 当前时间
        let randomStr = self.$randomString(4); //  4位随机字符串
        const extensionName = file.name.substr(file.name.indexOf(".")); // 文件扩展名
        let fileWay = "resource/image/";
        const fileName =
          fileWay + date + "/" + dateTime + "_" + randomStr + extensionName; // 文件名字（相对于根目录的路径 + 文件名）
        console.log(fileName);
        // 执行上传
        self.$createOssClient().then(client => {
          client
            .multipartUpload(fileName, file, {
              headers: { "Cache-Control": "public" }
            })
            .then(
              val => {
                if (val.res.statusCode === 200) {
                  self.imageUrl =
                    self.$GLOBAL.picFileUrl + val.name + self.$GLOBAL.xwPic; //展示图片

                  //cdn预热
                  self.$cdnFun(self.imageUrl).then(res => {
                    console.log(res);
                  });

                  return val;
                } else {
                  option.onError("上传失败1");
                }
              },
              err => {
                console.log(err);
                option.onError("上传失败");
                reject(err);
              }
            );
        });
      });
    },
    saveAlert() {
      console.log("保存修改");
      let _this = this;
      let param = {
        nickname: _this.nickName,
        headUrl: _this.imageUrl
      };
      _this
        .$post(`/request/member/editManager`, param, _this.$GLOBAL.jsonConfig)
        .then(res => {
          if (res.code === "00000") {
            _this.dialogVisible = true;

            _this.$propMessage("修改成功", "success", function() {
              localStorage.setItem("nickName", _this.nickName);
              localStorage.setItem("avatarPic", _this.imageUrl);
              location.reload();

              _this.dialogVisible = false;
            });
          } else {
            _this.dialogVisible = true;
            _this.$propMessage(res.message, "error", function() {
              _this.dialogVisible = false;
            });
          }
        });
    },
    // Method函数
    getUploadFile(file, fileList) {
      // // 上传成功后将图片地址赋值给裁剪框显示图片
      //     this.$nextTick(() => {
      //         this.option.img = file.url
      //         this.dialogVisiblePic = true
      //     })
      var files = file.raw;
      this.fileinfo = file; // 保存下当前文件的一些基本信息
      let reader = new FileReader(); // 创建文件读取对象
      reader.onload = async e => {
        let data;
        if (typeof e.target.result === "object") {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        this.option.img = data; // 设置option的初始image
        this.dialogVisiblePic = true;
      };
      reader.readAsArrayBuffer(files);
      this.option.fixedNumber = [1, 1]; // 图片的裁剪宽高比在这里也可以进行设置
    },
    // 上传，
    /*
     * 将上传添加到这里来执行
     */
    finish() {
      let self = this;
      //  this.$refs.fileUpload.$children[0].$el.click();
      self.$refs.cropper.getCropBlob(data => {
        // var fileName = self.fileinfo.uid
        return new Promise((resolve, reject) => {
          const date = self.$dateFormat(new Date(), "yyyy-MM-dd"); // 当前时间
          const dateTime = self.$dateFormat(new Date(), "yyyyMMddhhmmss"); // 当前时间
          let randomStr = self.$randomString(4); //  4位随机字符串
          const extensionName = ".jpg"; // 文件扩展名
          let fileWay = "resource/image/";
          const fileName =
            fileWay + date + "/" + dateTime + "_" + randomStr + extensionName; // 文件名字（相对于根目录的路径 + 文件名）
          console.log(fileName);
          // 执行上传
          self.$createOssClient().then(client => {
            client
              .multipartUpload(fileName, data, {
                headers: { "Cache-Control": "public" }
              })
              .then(
                val => {
                  if (val.res.statusCode === 200) {
                    self.imageUrl = self.$GLOBAL.picFileUrl + val.name; //展示图片

                    //cdn预热
                    self.$cdnFun(self.imageUrl).then(res => {
                      console.log(res);
                    });

                    self.dialogVisiblePic = false;

                    return val;
                  } else {
                    option.onError("上传失败1");
                  }
                },
                err => {
                  console.log(err);
                  option.onError("上传失败");
                  reject(err);
                }
              );
          });
        });
        // self.$createOssClient().then(client=>{
        //     client.multipartUpload(fileName, data, {
        //         headers:{'Cache-Control':'public'}
        //     }).then((val) => {
        //         if (val.res.statusCode === 200) {
        //         self.imageUrl = self.$GLOBAL.picFileUrl + val.name + self.$GLOBAL.xwPic //展示图片

        //         //cdn预热
        //         self.$cdnFun(self.imageUrl).then(res=>{
        //             console.log(res)
        //         })

        //         return val
        //         self.dialogVisiblePic = false;
        //         } else {
        //             option.onError('上传失败1')
        //         }
        //     }, err => {
        //         console.log(err)
        //         option.onError('上传失败')
        //         reject(err)
        //     })
        // }

        // )
      });
    }
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>

<style lang="less" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.cropper-content {
  .cropper {
    width: auto;
    height: 600px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/setting/accountSetting.vue